import { jwtDecode } from 'jwt-decode';
import { setDefault, setUser } from './actions';
import config from './config';
import { dispatch, store } from './store';

let refreshPromise = null;

export const isAccessTokenValid = (accessToken, now = Date.now()) => {
  try {
    const { exp } = jwtDecode(accessToken);
    return Number.isFinite(exp) && exp * 1000 > now;
  } catch {
    return false;
  }
};

export const clearSession = () => {
  dispatch(setDefault());
};

export const refreshAccessToken = () => {
  if (refreshPromise) return refreshPromise;

  const user = store.getState().user;
  if (!user?.refreshToken) {
    clearSession();
    return Promise.reject(new Error('Refresh token is unavailable'));
  }

  refreshPromise = fetch(config.REFRESH_TOKEN, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.refreshToken
    }
  })
    .then(async (response) => {
      if (!response.ok) throw new Error('Unable to refresh session');

      const data = await response.json();
      if (!data?.accessToken) throw new Error('Unable to refresh session');

      dispatch(
        setUser({
          ...user,
          accessToken: data.accessToken
        })
      );
      return data.accessToken;
    })
    .catch((error) => {
      clearSession();
      throw error;
    })
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
};
